// 人工各阶段状态
export enum IMSTATUS {
    INITAIZLIED = 0,
    STARTED = 1,
    WAITING = 2,
    PAUSED = 3,
    PROCESSING = 4,
    SETTYPE = 8,
    ENDED = 9
}
// 人工各状态
export enum IMSTATUS_NAME {
    status = 'status',
    EVALUATED = 'EVALUATED',
    EVAL_INVITED = 'EVAL_INVITED',
    CLOSED = 'CLOSED',
    EVALUATED_BY_CLOSE = 'EVALUATED_BY_CLOSE',
    COMMENTED = 'COMMENTED'
}
// 消息类型
export enum MSGTYPE {
    // 评价
    EVALUATED = 'EVALUATED',
    // 邀请评价
    EVALUATE_INVITE = 'EVALUATE_INVITE',
    // 等待人数
    WAITING_QUEUE = 'WAITING_QUEUE',
    // GM关闭
    CLOSE_BY_GM = 'CLOSE_BY_GM',
    // GM自动关闭
    CLOSE_BY_AUTO_GM = 'CLOSE_BY_AUTO_GM',
    // 用户结束
    CLOSE_BY_USER = 'CLOSE_BY_USER',
    // 用户离开
    CLOSE_BY_USER_LEFT = 'CLOSE_BY_USER_LEFT',

    // 超时
    TIMEOUT_SYSTEM = 'TIMEOUT_SYSTEM',
    KICKED = 'KICKED',
    // 无客服
    NOGM = 'CLOSE_NOGM',
    // 标记接入客服
    ACCEPT = 'ACCEPT',
    ASSIGNED = 'ASSIGNED',
    // 转单
    TRANSFERED = 'TRANSFERED',
    // 客服掉线了，没人啦
    TRANSFERED_NOBODY = 'TRANSFERED_NOBODY',
    // 通知
    NOTICE = 'NOTICE',
    // 留言
    COMMENTED = 'COMMENTED'
}

// 消息类型
export enum MESSAGE_TYPE {
    'revoke' = 'MESSAGE_REVOKE',
    'audit' = 'MESSAGE_AUDIT',
    'info' = 'info',
    'succ' = 'succ',
    'warn' = 'warn',
    'error' = 'error',
    'bugle' = 'bugle',
    'out' = 'out',
    'offline' = 'offline',
    'in' = 'in',
    'faq-init' = 'faq-init',
    'faq-questions' = 'faq-questions',
    'faq-resolve' = 'faq-resolve',
    'faq-art' = 'faq-art',
    'faq-loading' = 'faq-loading'
}
// 通知+消息
declare const MsgTypes: [
    'info',
    'succ',
    'warn',
    'error',
    'bugle',
    'out',
    'offline',
    'in',
    'faq-init',
    'faq-questions',
    'faq-resolve',
    'faq-art',
    'faq-loading',
    'MESSAGE_REVOKE',
    'MESSAGE_AUDIT',
    // 等待人数
    'WAITING_QUEUE',
    // 评价
    'EVALUATED',
    // 留言
    'COMMENTED',
    // GM关闭
    'CLOSE_BY_GM',
    // 用户结束
    'CLOSE_BY_USER',
    // 用户离开
    'CLOSE_BY_USER_LEFT',
    // 客服发送结束语境
    'CLOSE_BY_AUTO_GM',
    // 超时
    'TIMEOUT_SYSTEM',
    'KICKED',
    // 无客服
    'CLOSE_NOGM',
    'SET_QTYPE',
    // GM邀请评价
    'EVALUATE_INVITE',
    // 标记接入客服
    'ACCEPT',
    'ASSIGNED',
    // 转单
    'TRANSFERED',
    // 客服掉线了，没人啦
    'TRANSFERED_NOBODY',
    // 客服掉线了，转接其它客服
    'TRANSFERED_TIP',
    // 通知
    'NOTICE'
];

export declare type MsgType = (typeof MsgTypes)[number];
declare const LockBtns: ['comment'];

export declare type LockBtn = (typeof LockBtns)[number];
